import { useEffect } from "react";

interface ScriptLoaderProps {
  src: string;
  id: string;
  async?: boolean;
  defer?: boolean;
  onLoad?: () => void;
  onError?: () => void;
}

export function ScriptLoader({
  src,
  id,
  async = true,
  defer = false,
  onLoad,
  onError,
}: ScriptLoaderProps) {
  useEffect(() => {
    // Check if script already exists
    const existingScript = document.getElementById(id);
    if (existingScript) {
      if (onLoad) {
        onLoad();
      }
      return;
    }

    // Create script
    const script = document.createElement("script");
    script.id = id;
    script.src = src;
    script.type = "text/javascript";

    if (async) {
      script.async = true;
    }
    if (defer) {
      script.defer = true;
    }

    // Event listeners
    script.onload = () => {
      if (onLoad) {
        onLoad();
      }
    };

    script.onerror = () => {
      if (onError) {
        onError();
      }
    };

    // Append to document
    document.body.appendChild(script);

    // Cleanup
    return () => {
      if (document.getElementById(id)) {
        document.getElementById(id)?.remove();
      }
    };
  }, [src, id, async, defer, onLoad, onError]);

  return null;
}
